import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { IBlankslate, ITag, LayoutService, Status } from 'codex-lib';
import { Envelope } from '../../model/envelope';
import { LanguageUtil } from 'src/app/util/language-util';
import { TranslateService } from '@ngx-translate/core';
import { EnvelopeEditService } from '../../services/envelope-edit.service';
@Component({
  selector: 'app-edit-envelope-authorizers',
  templateUrl: './envelope-edit-authorizers.component.html',
  styleUrls: ['./envelope-edit-authorizers.component.scss']
})
export class EnvelopeEditAuthorizersComponent implements OnInit {

  envelope: Envelope = new Envelope();
  searchText = '';
  authorizersSelecteds: Array<number> = [];
  checkboxAllElements: boolean;
  filteredElements: any;
  envelopeLanguage = 1;
  tagWaiting: ITag = {
    description: 'envelope-edit.pending',
    type: Status.WARNING
  };
  tagApproved: ITag = {
    description: 'envelope-edit.approved',
    type: Status.INFO
  };
  tagReproved: ITag = {
    description: 'envelope-edit.reprovado',
    type: Status.DANGER
  };
  blankSlate: IBlankslate;

  constructor(
    public layoutService: LayoutService,
    private route: ActivatedRoute,
    private envelopeEditService: EnvelopeEditService,
    private translateService: TranslateService) {

  }

  ngOnInit(): void {
    this.route
      .params
      .subscribe((params: Params) => {
        this.envelopeEditService
          .getEnvelope(params['envelopeId'])
          .subscribe(envelope => {
            this.envelope = envelope;
            this.filteredElements = this.envelope.authorizers;
            this.envelopeLanguage = this.envelope.language;
          });
      });
      this.blankSlate = {
        icon: {
          prefix: 'fad',
          iconName: 'user-plus'
        },
        buttonText: 'add'
      };
  }

  ngOnDestroy(): void {
    this.layoutService.toggleViewer(false);
  }

  ngAfterViewInit(): void {

  }

  onSearch(textToSearch) {
    this.onCheckboxAll(false);
    if (textToSearch) {
      this.filteredElements = this.envelope.authorizers.filter(item =>
        Object.keys(item).some(
          k =>
            item[k] != null &&
            item[k]
              .toString()
              .toLowerCase()
              .includes(textToSearch.toLowerCase())
        )
      );
    } else {
      this.filteredElements = this.envelope.authorizers;
    }
  }

  anyCheckedElement(): void {

  }

  showConfirmationDelete(confirmModalContent) {

  }

  showAddAuthorizerModal(modalAddAuthorizer) {

  }

  onCheckbox(event, authorizer) {
    if(event) {
      this.authorizersSelecteds.push(authorizer.envelopeSignatoryId);
    } else {
      this.authorizersSelecteds = this.authorizersSelecteds.filter(function(envelopeSignatoryId, index, arr){
          return envelopeSignatoryId !== authorizer.envelopeSignatoryId;
      });
    }
  }


  onCheckboxAll(event){
    this.checkboxAllElements = event;
    this.envelope.authorizers.forEach((authorizer: any) => {
      this.onCheckbox(event, authorizer);
    });
  }

  isChecked(authorizer): boolean{
    return this.authorizersSelecteds.find(id => id  === authorizer.envelopeSignatoryId) !== undefined;
  }

  onBlankSlateSearchClick() {
    this.onSearch('');
  }

  checkLanguagePtEnvelope(){
    return LanguageUtil.isCurrentLanguagePT(this.envelopeLanguage) && LanguageUtil.isCurrentLanguagePT(this.translateService.currentLang);
  }
}
